<template>
  <div class="info-tip inline-flex relative md:py-3">
    <div class="w-full mx-auto">
      <div class="w-full flex justify-end">
      <KIcon
        name="information"
        class="w-3 md:w-5 h-3 md:h-5 fill-current text-primary"
        tabindex="0"
        @click="openModal"
        @keypress.enter.space="openModal"
      />
      </div>
      <KModal v-if="showDisclaimerModal" @close="showDisclaimerModal = false" ariaModalLabel="Disclaimer Modal" :alignPopUpAtTop="alignPopUpAtTop"  :styleOveride="true">
        <template #content>
          <div :aria-describedby="$id('disclaimerModalDescription')" :aria-labelledby="$id('disclaimerModalTitle')" class="flex flex-col items-center justify-center">
            <div :id="$id('disclaimerModalDescription')" class="modal-text-content text-sm px-4" v-dompurify-html="disclaimerText"/>
          </div>
        </template>
      </KModal>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { KIcon } from '@/components'
import KModal from '@/components/atoms/Modal/KModal.vue';
import KButton from '@/components/atoms/Button/index.vue';

export default defineComponent({
  name: 'KInformationToolTip',
  components: {
    KModal,
    KButton,
    KIcon
  },
  props: {
    disclaimerText: {
      type: String,
      default: ''
    },
    alignPopUpAtTop:{
      type: Boolean,
      default: false
    }
  },
  setup () {
    const showDisclaimerModal = ref(false)
    function openModal () {
      showDisclaimerModal.value = true
    }
    return { showDisclaimerModal, openModal }
  }
})
</script>
